import { axios } from "./axios";
import { t } from "../i18n";

// Downloads a file the server builds (Excel / PDF). The server rebuilds the whole result for the same
// filters, so the file holds every matching record, not just the visible page.
export async function downloadFile(path, params, filename) {
  const blob = await fetchBlob(path, params);
  saveBlob(blob, filename);
}

export async function fetchBlob(path, params) {
  try {
    const response = await axios.get(path, { params, responseType: "blob" });
    return response.data;
  } catch (err) {
    throw new Error(await errorMessage(err));
  }
}

// An error body arrives as a Blob when responseType is "blob": read its message.
export async function errorMessage(err) {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const body = JSON.parse(await data.text());
      return t(body.message || "تعذر إكمال العملية.");
    } catch (e) {
      return t("تعذر إكمال العملية.");
    }
  }
  return t(data?.message || "تعذر إكمال العملية.");
}

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
